enum PackVisibilityTypes {
  AccountType = "Account type",
  Account = "Account",
}

export default PackVisibilityTypes;
